"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackGA4EventWithCleanUp = void 0;
const clearGA4EventData_1 = require("./clearGA4EventData");
const pushToDataLayer_1 = require("./pushToDataLayer");
const trackGA4EventWithCleanUp = (eventObject, event) => {
    (0, clearGA4EventData_1.clearGA4EventData)();
    (0, pushToDataLayer_1.pushToDataLayer)({
        ...eventObject,
        event: event || 'JS_Event',
    });
};
exports.trackGA4EventWithCleanUp = trackGA4EventWithCleanUp;
//# sourceMappingURL=trackGA4EventWithCleanUp.js.map